import {mapState} from 'vuex'
import FormatService from '../../../services/format-service'

export default {
    name: 'Payables',
    data() {
        return {
        }
    },
    methods: {
        pay(receivable) {
            var url = `https://bunq.me/pixelhobby?amount=${receivable.openstaand}&description=${receivable.mut_factuur}`
            window.open(url, '_blank'); 
        }
    },
    computed: {
        ...mapState({
            receivables: state => state.account.receivables,
            user: state => state.account.user
        }),
    },
    created() {
        this.$store.dispatch('account/getReceivables');
    },
    filters: {
        euro(value) {
            return FormatService.euro(value);
        }
    }
}